<template>
  <Loader :stretch="true" :inverse="true"></Loader>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Loader from "@/components/shared/Loader.vue";

const store = useStore();
const router = useRouter();

onMounted(() => {
  store
    .dispatch("oidcStore/oidcSignInCallback", { useReplaceToNavigate: true })
    .then(async redirectPath => {
      const appInProgress = localStorage.getItem("appInProgress");

      if (appInProgress) {
        const appData = JSON.parse(appInProgress);

        await store.dispatch("setAppData", appData);
        router.push({ path: redirectPath, query: { lid: appData?.application?.lenderId, continue: "true" } });
      }
    })
    .catch(err => {
      console.error(err);
      router.push("/oidc-callback-error"); // Handle errors any way you want
    });
});
</script>
